import { render, staticRenderFns } from "./Wire.vue?vue&type=template&id=d228309e"
import script from "./Wire.vue?vue&type=script&lang=js"
export * from "./Wire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports